import React from "react";
import { CardBody, Card, CardHeader, CardFooter } from "../card/card.jsx";
import songGenres from "../../config/genres.js";

/* -------------------------------
   SongReelForm Component
   - Renders inputs for title, channel, genre, platform and video ID.
   - Also renders a grid of thumbnail images and the channel logo.
   - If a selected thumbnail background is passed via the prop "thumbnailBackground"
     (ensure this value is one of the items in "thumbnailBackgrounds"), it will be marked with a green border.
-------------------------------- */
const SongReelForm = ({
  songReelId,
  loading,
  title,
  setTitle,
  selectedChannel,
  setSelectedChannel,
  thumbnailBackgrounds,
  thumbnailBackground, // selected thumbnail background prop
  handleSelectThumbnailBackground,
  channels,
  logo,
  platform,
  setPlatform,
  videoId,
  setVideoId,
  handlePostNewReel
}) => {
  return (
    <Card>
      <CardHeader>
        <h4>Song Reel Details</h4>
      </CardHeader>
      <CardBody>
        <div className="mb-3">
          <label htmlFor="titleInput" className="form-label">Title</label>
          <input
            id="titleInput"
            type="text"
            className="form-control"
            placeholder="Enter title"
            value={title}
            maxLength={80} // Ensures the title cannot exceed 80 characters
            onChange={(e) => setTitle(e.target.value)}
          />
            {/* Optional: Display character count */}
          <div className="mb-1">
            <small>{title.length} / 80 characters</small>
          </div>
        </div>
        <div className="d-flex mb-3">
          <div className="me-3">
            <label htmlFor="channelSelect" className="form-label">Select Channel (Song Reels)</label>
            <select
              id="channelSelect"
              className="form-select"
              value={selectedChannel}
              onChange={(e) => setSelectedChannel(e.target.value)}
            >
              {channels.map((channel) => (
                <option key={channel._id} value={channel._id}>
                  {channel.name}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="d-flex mb-3">
          <div className="me-3">
            <label htmlFor="platformSelect" className="form-label">Platform</label>
            <select
              id="platformSelect"
              className="form-select"
              value={platform}
              onChange={(e) => setPlatform(e.target.value)}
            >
              <option value="instagram">Instagram</option>
              <option value="tiktok">Tiktok</option>
            </select>
          </div>
          <div>
            <label htmlFor="videoIdInput" className="form-label">
              {platform === "instagram" ? "Video Shortcode" : "Video ID"}
            </label>
            <input
              id="videoIdInput"
              type="text"
              className="form-control"
              placeholder={platform === "instagram" ? "Enter Instagram shortcode" : "Enter Tiktok video ID"}
              value={videoId}
              onChange={(e) => setVideoId(e.target.value)}
            />
          </div>
        </div>
        
        {/* Thumbnail Backgrounds Grid */}
        {thumbnailBackgrounds && thumbnailBackgrounds.length > 0 && (
          <div className="mb-3">
            <label className="form-label">Select Thumbnail Background</label>
            <div className="row row-cols-3 g-3">
              {thumbnailBackgrounds.map((thumbnail, index) => {
                const isSelected = thumbnailBackground === thumbnail;
                return (
                  <div key={index} className="col">
                    <img
                      src={`https://api.moatoverflow.com/statics/${thumbnail}`}
                      alt={`Thumbnail ${index}`}
                      className="img-thumbnail"
                      onClick={() => handleSelectThumbnailBackground(thumbnail)}
                      style={{
                        cursor: "pointer",
                        border: isSelected ? "2px solid green" : "none"
                      }}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* Channel Logo */}
        {logo && (
          <div className="mb-3">
            <label className="form-label">Channel Logo</label>
            <div>
              <img
                src={`https://api.moatoverflow.com/statics/${logo}`}
                alt="Channel Logo"
                className="img-fluid"
              />
            </div>
          </div>
        )}
        
      </CardBody>
      {!songReelId && (
        <CardFooter>
          <button className="btn btn-success me-2" onClick={handlePostNewReel} disabled={loading}>
            {loading ? "Posting Reel..." : "Post New Reel"}
          </button>
        </CardFooter>
      )}
    </Card>
  );
};

export default SongReelForm;
